/* Tiempo sin actividad antes de mostrar aviso (debe alinearse con la validez del JWT en el API). */
export const INACTIVE_USER_TIME_THRESHOLD = 12 * 60 * 60 * 1000; /* 12 h (ms) */

/* Antirrebote: con actividad del usuario, se pospone el umbral anterior como máximo una vez por este intervalo. */
export const USER_ACTIVITY_THROTTLER_TIME = 60 * 1000; /* 1 min (ms) */